import {
  InvoiceCategoryFilter,
  SettlementExportRendererKey,
  SettlementExportSide,
  SettlementExportStatus,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { Settlement } from '~hooks/useSettlements/models';
import {
  payableInvoiceCategories,
  receivableInvoiceCategories,
} from '~pages/Approvals/DriverPay/constants';

export const getSettlementExportSide = (category: InvoiceCategoryFilter | undefined) => {
  if (category && payableInvoiceCategories.includes(category)) {
    return SettlementExportSide.PAYABLE;
  }

  if (category && receivableInvoiceCategories.includes(category)) {
    return SettlementExportSide.RECEIVABLE;
  }

  return null;
};

// Keyed on the full renderer registry rather than the company's enabled renderers,
// so a batch made by a renderer that was later disabled still has a label.
export const getSettlementExportRendererLabel = (
  rendererKey: SettlementExportRendererKey,
) => {
  const rendererLabels: Record<SettlementExportRendererKey, string> = {
    [SettlementExportRendererKey.SAGE_PAYABLE]: t(
      'approvals.driver_pay.settlements.settlement_export.renderers.sage_payable',
    ),
    [SettlementExportRendererKey.SAGE_RECEIVABLE]: t(
      'approvals.driver_pay.settlements.settlement_export.renderers.sage_receivable',
    ),
  };

  return rendererLabels[rendererKey];
};

// Each export integration records success in its own place, so a settlement counts
// as exported when any of them says so. A pending batch is still generating, so
// exporting again would duplicate it.
export const isSettlementAlreadyExported = (settlement: Settlement) => {
  const hasCompletedSettlementExport =
    settlement.lastSettlementExport?.status === SettlementExportStatus.COMPLETED ||
    settlement.lastSettlementExport?.status === SettlementExportStatus.PENDING;
  const hasRutterExport = Boolean(settlement.rutterSettlementExport?.exportedAt);
  const hasExportedAt = Boolean(settlement.exportedAt);

  return hasCompletedSettlementExport || hasRutterExport || hasExportedAt;
};
